<template>
  <div class="token-top-block bg--color-01 pt-32 pt-64--m pb-32 pb-64--m">
    <div class="token-top-block__container container-new">
      <span
        class="token-top-block__title txt txt--36px txt--60px--m txt--height-44px txt--height-60px--m txt--color-04 txt--bold"
      >
        {{ $t('tokenNew.topBlock.title') }}
      </span>

      <span
        class="token-top-block__description txt txt--16px txt--22px--m txt--height-20px txt--height-30px--m txt--color-03"
        v-html="$t('tokenNew.topBlock.subtitle')"
      />

      <div class="token-top-block__buttons">
        <button-with-arrow
          class="token-top-block__button txt--bold txt--14px txt--height-18px flx flx--center"
          color="dark"
          :full-width="isMobile"
          :size="isMobile ? 'm' : 'l'"
          href="https://patex.io/"
          target="__blank"
        >
          {{ $t('common.discoverMore') }}
        </button-with-arrow>
        <!--
        <exc-button
          class="txt--bold txt--14px txt--height-18px flx flx--center"
          color="dark"
          :full-width="isMobile"
          :size="isMobile ? 'm' : 'l'"
          outline
          @click="downloadFile('tokenomics.pdf')"
        >
          <span class="flx flx--center txt--color-04">
            {{ $t('tokenNew.topBlock.tokenomicsBtn') }}
            <IconBtn />
          </span>
        </exc-button> -->
      </div>

      <div class="token-top-block__image">
        <!-- <img :src="require('@/assets/img/token/top-block-image-soon.svg')"> -->
        <!-- <img :src="require('@/assets/img/token/gifs/top-block-color.gif')"> -->
        <video
          loop
          autoplay
          muted
          playsinline
          class="how-to-deploy-block__video-block"
        >
          <source
            :src="require('@/assets/img/token/gifs/top-block.mp4')"
            type="video/mp4"
          >
          Your browser does not support the video tag.
        </video>
      </div>
    </div>

    <div class="token-top-block__stats container-new mt-32 mt-64--m">
      <div
        v-for="(item, index) in stats"
        :key="index"
        class="token-top-block__stat-item"
      >
        <span
          class="token-top-block__stat-item-value txt--bold txt--26px txt--height-34px txt--color-04"
        >
          <span v-if="item.isSoon">$ ***</span>
        </span>

        <span
          class="token-top-block__stat-item-label txt--weight-400 txt--16px txt--22px--l txt--height-20px txt--height-30px--l txt--color-04"
        >
          {{ item.label }}
        </span>

        <div
          class="token-top-block__stat-item-soon bg--color-10 txt txt--color-04 txt--14px"
        >
          {{ $t('common.promo.comingSoon') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ExcButton } from '@/components/common'
import { downloadLocalizedFile } from '@/lib/utils'

export default {
  name: 'TokenTopBlock',
  components: {
    ExcButton,
    IconBtn: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/img/token/btn-icon.svg?inline'
      ),
    ButtonWithArrow: () =>
      import('@/components/welcome/elements/ButtonWithArrow.vue'),
  },
  computed: {
    isMobile () {
      if (!process.client) return

      return this.$mq.resize && this.$mq.below(768)
    },

    stats () {
      return [
        {
          to: 0,
          isSoon: true,
          label: this.$t('tokenNew.topBlock.price'),
        },
        {
          to: 0,
          isSoon: true,
          label: this.$t('tokenNew.topBlock.24hValue'),
        },
        {
          to: 0,
          isSoon: true,
          label: this.$t('tokenNew.topBlock.marketCap'),
        },
      ]
    },
  },
  methods: {
    downloadFile (name) {
      downloadLocalizedFile(name, this.$i18n.locale)
    },
  },
}
</script>

<style lang="scss" scoped>
.token-top-block {
  &__container {
    display: grid;
    gap: toRem(24px);
    // align-items: center;
    grid-template-areas:
      'title'
      'image'
      'description'
      'buttons';

    @include bp(m) {
      grid-template-columns: 1fr 1fr;
      align-items: center;
      grid-template-areas:
        'title image'
        'description image'
        'buttons image';
    }

    @include bp(1200px) {
      gap: toRem(0px) toRem(24px);
    }
  }

  &__title {
    grid-area: title;
    align-self: flex-end;
  }

  &__description {
    grid-area: description;
  }

  &__buttons {
    grid-area: buttons;
    display: grid;
    align-self: flex-start;
  }

  &__button {
    @include bp(m) {
      width: fit-content;
    }
  }

  &__image {
    grid-area: image;

    img,
    video {
      width: 100%;
      max-width: 100%;
    }

    @include bp(0px, m) {
      text-align: center;

      img,
      video {
        max-width: toRem(380px);
      }
    }
  }

  &__stats {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
    align-items: center;
    gap: toRem(20px);

    @include bp(700px) {
      grid-template-rows: unset;
      grid-template-columns: repeat(3, 1fr);
    }

    @include bp(1200px) {
      // display: flex;
      // flex-direction: row;
      // justify-content: space-between;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: unset;
    }

    // @include bp(0px, 1200px) {
    //   div:nth-child(1) {
    //     grid-column-end: span 2;
    //   }
    // }

    @include bp(1200px) {
      div:nth-child(2) {
        justify-self: center;
      }

      div:nth-child(3) {
        justify-self: flex-end;
      }
    }
  }

  &__stat-item {
    padding-left: toRem(10px);
    border-left: 1px solid color(transp-03);
    position: relative;

    display: grid;
    align-items: center;
    grid-template-columns: 1fr auto;
    gap: toRem(4px) toRem(14px);

    grid-template-areas:
      'value soon'
      'label soon';

    @include bp(700px) {
      grid-template-areas:
        'soon'
        'value'
        'label';
    }

    @include bp(992px) {
      gap: toRem(14px);
    }

    @include bp(1200px) {
      flex-direction: column;
      border: none;
      padding: 0;
      gap: toRem(14px);
      min-height: toRem(70px);

      display: grid;
      grid-template-columns: repeat(3, max-content);
      grid-template-areas: 'value label soon';
    }

    // @include bp(1200px) {
    //   flex-direction: row;
    //   // align-items: flex-end;
    //   align-items: center;
    // }
  }

  &__stat-item-label {
    grid-area: label;
  }

  &__stat-item-value {
    grid-area: value;

    @include bp(l) {
      font-size: toRem(44px);
      line-height: toRen(58px);
    }

    span {
      white-space: nowrap;
    }
  }

  &__stat-item-soon {
    grid-area: soon;

    margin-top: auto;
    margin-bottom: auto;

    @include bp(m) {
      align-self: flex-start;
    }

    padding: toRem(4px) toRem(8px);
    border-radius: toRem(20px);
    max-width: fit-content;
  }
}
</style>
